module.exports = __webpack_public_path__ + "public/img/komunikasi dan negosiasi untuk tenaga pemasaran-2.0d4d0159.png";